import { useEffect, useRef, FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { CheckInfoType } from 'adapters/types';
import { ComposedTable } from 'components';
import {
  getPaymentDate,
  getPrintedChecksFormatted,
  getPrintedChecksWithoutErrors,
  selectPrintedOkChecks
} from 'pages/VendorsTablePage/components/PrintChecks';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { formatLocaleDate } from 'utils/dateUtils';
import {
  PRINT_SUCCESS_TABLE_HEIGHT,
  PRINT_SUCCESS_TABLE_WIDTH
} from '../constants';
import { StyledMessage, StyledDialogMessage } from './styled';
import { usePrintSuccessDialogColumns } from './usePrintSuccessDialogColumns';

export const PrintSuccessDialogContent: FC = () => {
  const dispatch = useAppDispatch();
  const intl = useIntl();
  const successChecks = useAppSelector(getPrintedChecksFormatted);
  const checksWithoutErrors = useAppSelector(getPrintedChecksWithoutErrors);
  const enableChecksFlag = useRef<boolean>(true);
  const columnDefs = usePrintSuccessDialogColumns();
  const paymentDate = useAppSelector(getPaymentDate);
  const formattedPaymentDate = formatLocaleDate(paymentDate, intl.locale);

  useEffect(() => {
    if (checksWithoutErrors.length && enableChecksFlag.current) {
      dispatch(
        selectPrintedOkChecks({ checks: checksWithoutErrors, selected: true })
      );
      enableChecksFlag.current = false;
    }
  }, [checksWithoutErrors, dispatch, enableChecksFlag]);

  return (
    <>
      <FormattedMessage
        defaultMessage="{StyledMessageLabel}"
        description="Payment Date for success dialog"
        values={{
          StyledMessageLabel: (
            <StyledDialogMessage>
              <StyledMessage>
                <FormattedMessage
                  defaultMessage="Payment Date"
                  description="Label for Payment Date in print dialog"
                />
              </StyledMessage>
              {formattedPaymentDate}
            </StyledDialogMessage>
          )
        }}
      />
      <ol>
        <li>
          <FormattedMessage
            defaultMessage="Select checks that printed successfully and click Post Selected to remove them from the list."
            description="Success message for post selected action"
          />
        </li>
        <li>
          <FormattedMessage
            defaultMessage="Void and/or reprint any checks remaining in the list."
            description="Success message for void and reprint"
          />
        </li>
      </ol>
      <ComposedTable<CheckInfoType>
        columnDefs={columnDefs}
        customHeight={PRINT_SUCCESS_TABLE_HEIGHT}
        customWidth={PRINT_SUCCESS_TABLE_WIDTH}
        defaultColDef={{
          sortable: false
        }}
        isDownloadable={false}
        isPrintable={false}
        isSearchable={false}
        pagination={false}
        rowData={successChecks}
        suppressPaginationPanel
        useCustomHeader
        hideTableBorder
      />
    </>
  );
};
